import styled from '@emotion/styled';
import { Colors } from '../../../../../../../../colors';

export const TbAlertStyled = {
  Container: styled.div<any>`
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.2);
    background-color: ${Colors.White};
  `,
  Title: styled.p<any>`
    font-family: EncodeSans-SemiBold;
    font-size: 14px;
    margin-top: 10px;
  `,
  Description: styled.p<any>`
    font-family: EncodeSans-Medium;
    font-size: 10px;
    color: ${Colors.UnderlinedGrey};
    margin-top: 8px;
    margin-bottom: 12px;
  `,
  Error: styled.p<any>`
    font-family: EncodeSans-Medium;
    font-size: 10px;
    color: ${Colors.Red};
    margin-top: 8px;
  `,
  ContainerOnClick: styled.div<any>`
    display: flex;
    align-items: center;
  `,
};
